'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = ['M192 96l0 32 192 0 0-32c0-53-43-96-96-96s-96 43-96 96zm72 160l0 254.2c7.8 1.2 15.8 1.8 24 1.8s16.2-.6 24-1.8l0-254.2-48 0z', 'M531.2 153.6l25.6-19.2-38.4-51.2c-5 3.7-46.2 34.7-123.7 92.8l-213.3 0C103.8 117.9 62.6 86.9 57.6 83.2L19.2 134.4C26.7 140 62.9 167.2 128 216l0 40-128 0 0 64 128 0 0 32c0 2.6 .1 5.3 .2 7.9-65.2 48.9-101.6 76.2-109 81.7l38.4 51.2c10.8-8.1 40.4-30.3 88.7-66.5 23.2 44.2 66.5 76.2 117.7 83.9l0-254.2 48 0 0 254.2c51.2-7.7 94.5-39.7 117.7-83.9 48.3 36.2 77.8 58.4 88.7 66.5l38.4-51.2c-7.4-5.6-43.8-32.8-109-81.7 .1-2.6 .2-5.2 .2-7.9l0-32 128 0 0-64-128 0 0-40 83.2-62.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;